import { useState } from 'react';
import Modal from '@mui/material/Modal';
import CircularProgress from '@mui/material/CircularProgress';
import { IoClose as Close } from 'react-icons/io5';
import { MdGroups as Teams } from 'react-icons/md';
import { BiTrash as Delete } from 'react-icons/bi';
import { MdWarning as Warning } from 'react-icons/md';
import TeamService from '@Helpers/URLHelpers/TeamService';
import ErrorHandler from '@Root/ErrorHandler';
import './DeleteTeamForm.scss';

export default function DeleteTeamForm(props) {

    const [cursor, setCursor] = useState('auto');
    const teamService = new TeamService();
    const errorHandler = new ErrorHandler();
    const className = 'deleteTeamForm';

    const handleDelete = async(e) => {
        e.preventDefault();
        setCursor('wait');
        try {
            await teamService.deleteTeam(props.team);
            props.reloadData();
        } catch (err) {
            errorHandler.handleError(err);
        }
        setCursor('auto');
        props.closePopup();
    };

    return (
        <Modal
            open={props.open}
            onClose={props.closePopup}
            style={{ cursor: cursor }}
            className={className}
        >
            <div className={`${className}__backdrop`}>
                <div className={`${className}__container`}>
                    {/* Header */}
                    <div className={`${className}__header`}>
                        <div className={`${className}__header__left`}>
                            <div className={`${className}__header__icon`}>
                                <Delete />
                            </div>
                            <div className={`${className}__header__title`}>
                                Delete Team
                            </div>
                        </div>
                        <button 
                            className={`${className}__header__close`}
                            onClick={props.closePopup}
                            disabled={cursor === 'wait'}
                        >
                            <Close />
                        </button>
                    </div>

                    {/* Content */}
                    <div className={`${className}__content`}>
                        {/* Team Info */}
                        <div className={`${className}__team`}>
                            <div className={`${className}__team__icon`}>
                                <Teams />
                            </div>
                            <div className={`${className}__team__info`}>
                                <div className={`${className}__team__tag`}>
                                    {props.team?.tag}
                                </div>
                                <div className={`${className}__team__name`}>
                                    {props.team?.teamName}
                                </div>
                            </div>
                        </div>

                        {/* Warning */}
                        <div className={`${className}__warning`}>
                            <Warning className={`${className}__warning__icon`} />
                            <div className={`${className}__warning__content`}>
                                <h4 className={`${className}__warning__title`}>
                                    Are you sure you want to delete this team?
                                </h4>
                                <p className={`${className}__warning__desc`}>
                                    This action cannot be undone. Deleting this team will:
                                </p>
                                <ul className={`${className}__warning__list`}>
                                    <li>Remove all team members and their permissions</li>
                                    <li>Delete all team-related data permanently</li>
                                    <li>Remove the team from all projects</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    {/* Actions */}
                    <div className={`${className}__actions`}>
                        <button 
                            className={`${className}__actions__cancel`}
                            onClick={props.closePopup}
                            disabled={cursor === 'wait'}
                        >
                            Cancel
                        </button>
                        <button 
                            className={`${className}__actions__delete`}
                            onClick={handleDelete}
                            disabled={cursor === 'wait'}
                        >
                            {cursor === 'wait' ? (
                                <>
                                    <CircularProgress size={16} color="inherit" />
                                    Deleting...
                                </>
                            ) : (
                                <>
                                    <Delete />
                                    Delete Team
                                </>
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    );
}
